// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import CompanyLogos from './CompanyLogos'; 

// const Home = () => {
//   const [isPopupOpen, setIsPopupOpen] = useState(false); 
//   const [activeTab, setActiveTab] = useState(0); // 0 = Dashboard, 1 = Reports, 2 = Analysis
//   const [isExporting, setIsExporting] = useState(false);

//   const [isAnimalsOpen, setIsAnimalsOpen] = useState(true);
//   const [isInfraOpen, setIsBusinessOpen] = useState(false); // New list starts closed

//   const openPopup = () => setIsPopupOpen(true);
//   const closePopup = () => setIsPopupOpen(false);

//   const handleExport = () => {
//     setIsExporting(true);
//     setTimeout(() => setIsExporting(false), 2000);
//   };

//   return (
//     <div className="home-container" style={{ fontFamily: 'Inter, sans-serif', color: '#0f172a' }}>
      
//       {/* 1. HERO SECTION */}
//       <section id="hero" style={heroSectionStyle}>
//         <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
//           <h1 style={mainHeaderStyle}>Enterprise Architecture for <br/> <span style={{color: '#007bff'}}>Institutional Data Systems</span></h1>
//           <p style={heroSubtextStyle}>
//             Yellow Ray Consulting engineers high-performance software and relational models designed to survive shifting industry standards.
//           </p>
//           <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
//             <button onClick={openPopup} style={primaryButtonStyle}>Discuss Your Architecture</button>
//             <Link to="/case-studies" style={secondaryLinkStyle}>View Success Stories</Link>
//           </div>
//         </div>
//       </section>

//       {/* 2. LOGO GRID */}
//       <section style={ribbonStyle}>
//         <p style={ribbonTextStyle}>Partnered with National Research Initiatives  & Industry Groups</p>
//         <CompanyLogos /> 
//       </section>

//       {/* 3. INTERACTIVE PLATFORM PREVIEW */}
//       <section id="platform-preview" style={{ padding: '80px 20px', backgroundColor: '#f4f6f9', textAlign: 'center' }}>
//         <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
//           <h2 style={{ fontSize: '32px', fontWeight: '800', marginBottom: '10px' }}>Platform Interface Preview</h2>
//           <p style={{ color: '#64748b', marginBottom: '40px' }}>Interface preview of our custom reporting and data access portal.</p>

//           <div style={browserFrameStyle}>
//             <div style={browserHeaderStyle}>
//               <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//                 <div style={dotStyle('#ff5f56')} />
//                 <div style={dotStyle('#ffbd2e')} />
//                 <div style={dotStyle('#27c93f')} />
//                 <span style={breadcrumbStyle}>
//                    Beef &gt; {activeTab === 0 ? 'Dashboard' : activeTab === 1 ? 'View Reports' : 'Analysis'}
//                 </span>
//               </div>
//               <div style={tabSwitcherStyle}>
//                 <button onClick={() => setActiveTab(0)} style={activeTab === 0 ? activeBtn : inactiveBtn}>🏠 Dashboard</button>
//                 <button onClick={() => setActiveTab(1)} style={activeTab === 1 ? activeBtn : inactiveBtn}>📊 View Reports</button>
//                 <button onClick={() => setActiveTab(2)} style={activeTab === 2 ? activeBtn : inactiveBtn}>🧬 Analysis</button>
//               </div>
//               <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#94a3b8' }}>USER: REASEARCH_01</div>
//             </div>

//             <div style={{ display: 'flex', minHeight: '520px' }}>
//               <div style={sidebarStyle}>
//   <div style={sidebarLabelStyle}>NAVIGATION TREE</div>
  
//   {/* --- SECTION 1: ANIMALS --- */}
//   <div 
//     onClick={() => setIsAnimalsOpen(!isAnimalsOpen)}
//     style={folderHeaderStyle}
//   >
//     <span>{isAnimalsOpen ? '▼' : '▶'} 📂 Animals</span>
//   </div>

//   <div style={collapseContainer(isAnimalsOpen)}>
//     <div style={activeTab === 1 ? sidebarItemActive : sidebarItem}>🥩 Beef</div>
//     <div style={sidebarItem}>🐖 Swine</div>
//     <div style={sidebarItem}>🐔 Chickens</div>
//     <div style={sidebarItem}>🦃 Turkeys</div>
//   </div>

//   <div style={{ margin: '10px 0' }}></div> {/* Spacer */}

//   {/* --- SECTION 2: INFRASTRUCTURE / BUSINESS --- */}
//   <div 
//     onClick={() => setIsBusinessOpen(!isInfraOpen)}
//     style={folderHeaderStyle}
//   >
//     <span>{isInfraOpen ? '▼' : '▶'} 📂 Infrastructure</span>
//   </div>

//   <div style={collapseContainer(isInfraOpen)}>
//     <div style={sidebarItem}>📊 System Audit Logs</div>
//     <div style={sidebarItem}>💼 Financial Metrics</div>
//     <div style={sidebarItem}>🔑 Access Control</div>
//     <div style={sidebarItem}>📑 Export History</div>
//   </div>

//   <div style={{ marginTop: 'auto', padding: '20px', color: '#4ade80', fontSize: '12px', borderTop: '1px solid #334155' }}>
    
//   </div>
// </div>

//               <div style={{ flex: 1, padding: '0', textAlign: 'left', backgroundColor: '#fff', display: 'flex', flexDirection: 'column' }}>
//                 {activeTab === 0 && (
//   <div style={{ padding: '30px' }}>
//     <h3 style={tabTitleStyle}>Dashboard</h3>
//     <p style={tabSubStyle}>Real-time system monitoring and project metrics.</p>
    
//     <div style={dashboardGrid}>
//       <div style={statCard}>Total Records<br/><span style={statNum}>1,248,302</span></div>
//       <div style={statCard}>Active Surveys<br/><span style={statNum}>14</span></div>
//       <div style={statCard}>System Uptime<br/><span style={statNum}>99.9%</span></div>
//     </div>

//     {/* NEW RECENT ACTIVITY LOG SECTION */}
//     <div style={logContainer}>
//       <div style={logHeader}>
//         <span>System Activity Log</span>
//         <span style={{ color: '#10b981' }}>● Live</span>
//       </div>
      
//       <div style={logBody}>
//         <div style={logItem}>
//           <span style={logIcon}>📥</span>
//           <div style={logText}>
//             <strong>Report Exported:</strong> Swine Report (Excel/xlsx)
//             <br/><span style={logTime}>5 minutes ago • User: RESEARCH_04</span>
//           </div>
//         </div>

//         <div style={logItem}>
//           <span style={logIcon}>🔄</span>
//           <div style={logText}>
//             <strong>Metadata Updated:</strong> Beef field array
//             <br/><span style={logTime}>3 hours ago • User: System_Architect</span>
//           </div>
//         </div>

//         <div style={logItem}>
//           <span style={logIcon}>👤</span>
//           <div style={logText}>
//             <strong>User Login:</strong> Session initialized for Reviewer_01
//             <br/><span style={logTime}>4 hours ago • IP: 192.168.1.XX</span>
//           </div>
//         </div>

//         <div style={{ ...logItem, borderBottom: 'none' }}>
//           <span style={logIcon}>📑</span>
//           <div style={logText}>
//             <strong>Records Staged:</strong> Chicken Surveillance
//             <br/><span style={logTime}>Yesterday • Source: Staging_Environment</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// )}

//                 {activeTab === 1 && (
//                   <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//                     <div style={gridToolbar}>
//                       <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
//                         <span style={gridStat}># of Rows: 1,248</span>
//                         <span style={gridStat}># of Columns: 32</span>
//                       </div>
//                       <button onClick={handleExport} style={exportBtn}>
//                         {isExporting ? '⌛ Exporting...' : '📥 Export to Excel (xlsx)'}
//                       </button>
//                     </div>
//                     <div style={delphiGridStyle}>
//                       <div style={gridHeader}>
//                         <div style={gridCell}>Year</div>
//                         <div style={gridCell}>Code</div>
//                         <div style={gridCell}>ID</div>
//                         <div style={gridCell}>Class</div>
//                         <div style={gridCell}>Dosage (mg/kg)</div>
//                       </div>
//                       {[1, 2, 3, 4, 5, 6].map(i => (
//                         <div key={i} style={gridRow(i % 2 === 0)}>
//                           <div style={gridCell}>2026</div>
//                           <div style={gridCell}>VET{i}</div>
//                           <div style={gridCell}>HRD{i}</div>
//                           <div style={gridCell}>{(Math.random() * 10).toFixed(2)}</div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {activeTab === 2 && (
//                   <div style={{ display: 'flex', height: '100%' }}>
//                     <div style={dbTreeStyle}>
//                       <div style={sidebarLabelStyle}>PROJECT DATABASE</div>
//                       <div style={treeItem}>▼ Public_Surveillance</div>
//                       <div style={treeSubItem}>• Staging</div>
//                       <div style={treeSubItem}>• Reports</div>
//                       <div style={treeItem}>▶ Authorize</div>
//                     </div>
//                     <div style={{ flex: 1, padding: '20px', backgroundColor: '#1e293b' }}>
//                       <div style={codeEditorHeader}>SQL Syntax Editor</div>
//                       <pre style={codeStyle}>
//                         {`SELECT \n  t00.year, \n  t00.code, \n  t01.agent \nFROM \n  "public"."beef_master" t00 \nINNER JOIN "public"."agents" t01 \nORDER BY t00.year DESC;`}
//                       </pre>
//                       <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
//                         <button style={analysisBtn('#10b981')}>🚀 Run Query</button>
//                         <button style={analysisBtn('#6366f1')}>📊 Use R-Studio</button>
//                         <button style={analysisBtn('#007bff')}>📈 Use SPSS</button>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 4. FOOTER */}
//       <section style={{ padding: '100px 20px', textAlign: 'center', backgroundColor: '#0f172a', color: '#fff' }}>
//         <h2 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '20px' }}>Systems Built for the Long Term</h2>
//         <p style={{ maxWidth: '700px', margin: '0 auto 40px', color: '#94a3b8', fontSize: '18px' }}>
//           Our relational models and analysis pipelines have powered national research initiatives for over 15 years.
//         </p>
//         <Link to="/case-studies" style={footerCtaStyle}>Explore Success Stories →</Link>
//       </section>

//       {/* 5. POPUP MODAL */}
//       {isPopupOpen && (
//         <div style={overlayStyle}>
//           <div style={popupStyle}>
//             <h2 style={headerStyle}>Discuss Your Architecture</h2>
//             <p style={taglineStyle}>Connect with our engineering team for a feasibility review.</p>
//             <div style={{ margin: '30px 0', padding: '20px', backgroundColor: '#f1f5f9', borderRadius: '8px' }}>
//               <a href="mailto:info@yrcgi.com" style={emailLinkStyle}>info@yrcgi.com</a>
//             </div>
//             <button onClick={closePopup} style={closeButtonStyle}>Close Window</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // ================= STYLES =================

// const dotStyle = (color) => ({ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: color });
// const gridRow = (isEven) => ({ display: 'grid', gridTemplateColumns: '80px 100px 100px 1fr 120px', backgroundColor: isEven ? '#fcfcfd' : '#fff', borderBottom: '1px solid #f1f5f9', fontSize: '13px' });
// const analysisBtn = (color) => ({ backgroundColor: color, color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '4px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' });

// const breadcrumbStyle = { marginLeft: '12px', fontSize: '12px', fontWeight: '600', color: '#94a3b8', fontFamily: 'monospace' };
// const browserFrameStyle = { backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 30px 60px -12px rgba(0,0,0,0.15)' };
// const browserHeaderStyle = { backgroundColor: '#0f172a', padding: '12px 25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' };

// const tabSwitcherStyle = { display: 'flex', gap: '4px', backgroundColor: '#1e293b', padding: '4px', borderRadius: '8px' };
// const activeBtn = { backgroundColor: '#007bff', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' };
// const inactiveBtn = { backgroundColor: 'transparent', color: '#94a3b8', border: 'none', padding: '6px 14px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' };

// //const sidebarStyle = { width: '220px', backgroundColor: '#1e293b', display: 'flex', flexDirection: 'column', textAlign: 'left', padding: '25px 0', borderRight: '1px solid #334155' };
// const sidebarLabelStyle = { fontSize: '10px', fontWeight: '800', color: '#38bdf8', padding: '0 20px 12px', letterSpacing: '1px' };
// //const sidebarItem = { padding: '10px 20px', fontSize: '13px', color: '#94a3b8' };
// //const sidebarItemActive = { ...sidebarItem, backgroundColor: '#334155', color: '#fff', borderLeft: '4px solid #007bff' };

// const gridToolbar = { padding: '15px 25px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc' };
// const gridStat = { fontSize: '12px', fontWeight: '700', color: '#64748b' };
// const exportBtn = { backgroundColor: '#10b981', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' };
// const delphiGridStyle = { flex: 1, overflowY: 'auto' };
// const gridHeader = { display: 'grid', gridTemplateColumns: '80px 100px 100px 1fr 120px', backgroundColor: '#f1f5f9', borderBottom: '1px solid #e2e8f0', fontWeight: 'bold', fontSize: '11px', color: '#475569', textTransform: 'uppercase' };
// const gridCell = { padding: '12px' };

// const dbTreeStyle = { width: '200px', borderRight: '1px solid #334155', backgroundColor: '#0f172a', padding: '20px 0', textAlign: 'left' };
// const treeItem = { padding: '8px 20px', color: '#fff', fontSize: '12px', fontWeight: 'bold' };
// const treeSubItem = { padding: '6px 35px', color: '#38bdf8', fontSize: '11px' };

// const codeStyle = { color: '#4ade80', fontSize: '13px', lineHeight: '1.6', fontFamily: 'monospace', whiteSpace: 'pre-wrap' };
// const codeEditorHeader = { color: '#94a3b8', fontSize: '11px', marginBottom: '15px', textTransform: 'uppercase', letterSpacing: '1px' };

// const tabTitleStyle = { fontSize: '24px', fontWeight: '800', marginBottom: '10px' };
// const tabSubStyle = { fontSize: '15px', color: '#64748b', marginBottom: '30px' };
// const dashboardGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', marginBottom: '30px' };
// const statCard = { padding: '20px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '12px', color: '#64748b' };
// const statNum = { fontSize: '24px', fontWeight: '900', color: '#0f172a' };

// const heroSectionStyle = { padding: '120px 20px', textAlign: 'center', background: 'radial-gradient(circle at center, #fff 0%, #f8fafc 100%)' };
// const mainHeaderStyle = { fontSize: '56px', fontWeight: '900', letterSpacing: '-1px', marginBottom: '25px' };
// const heroSubtextStyle = { fontSize: '20px', color: '#475569', maxWidth: '850px', margin: '0 auto 40px', lineHeight: '1.6' };

// const primaryButtonStyle = { backgroundColor: '#007bff', color: '#fff', padding: '16px 32px', borderRadius: '6px', fontWeight: '700', border: 'none', cursor: 'pointer', fontSize: '16px' };
// const secondaryLinkStyle = { backgroundColor: 'transparent', color: '#0f172a', padding: '16px 32px', borderRadius: '6px', fontWeight: '700', border: '1px solid #cbd5e1', textDecoration: 'none', display: 'inline-block' };

// const ribbonStyle = { padding: '40px 20px', backgroundColor: '#fff', borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', textAlign: 'center' };
// const ribbonTextStyle = { fontSize: '11px', fontWeight: '800', letterSpacing: '2px', color: '#94a3b8', marginBottom: '25px' };

// const footerCtaStyle = { display: 'inline-block', backgroundColor: '#007bff', color: '#fff', padding: '16px 32px', borderRadius: '6px', fontWeight: '700', textDecoration: 'none' };

// const overlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(15, 23, 42, 0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
// const popupStyle = { backgroundColor: '#fff', padding: '50px', borderRadius: '20px', maxWidth: '500px', width: '90%', textAlign: 'center' };
// const emailLinkStyle = { fontSize: '24px', fontWeight: '800', color: '#007bff', textDecoration: 'none' };
// const headerStyle = { fontSize: '28px', fontWeight: '800', marginBottom: '10px' };
// const taglineStyle = { color: '#64748b', fontSize: '16px' };
// const closeButtonStyle = { background: 'none', border: 'none', color: '#94a3b8', textDecoration: 'underline', cursor: 'pointer', marginTop: '20px' };

// // Function to handle the opening/closing animation
// const collapseContainer = (isOpen) => ({
//   maxHeight: isOpen ? '300px' : '0',
//   overflow: 'hidden',
//   transition: 'all 0.3s ease-in-out',
//   paddingLeft: '10px' // Indent nested items
// });

// const folderHeaderStyle = {
//   padding: '10px 20px',
//   fontSize: '13px',
//   color: '#fff',
//   cursor: 'pointer',
//   display: 'flex',
//   alignItems: 'center',
//   userSelect: 'none',
//   fontWeight: '600'
// };

// const sidebarStyle = { 
//   width: '240px', 
//   backgroundColor: '#1e293b', 
//   display: 'flex', 
//   flexDirection: 'column', 
//   textAlign: 'left', 
//   padding: '25px 0',
//   borderRight: '1px solid #334155'
// };

// const sidebarItem = { 
//   padding: '8px 25px', 
//   fontSize: '12px', 
//   color: '#94a3b8',
//   cursor: 'default'
// };

// const sidebarItemActive = { 
//   ...sidebarItem, 
//   backgroundColor: '#334155', 
//   color: '#fff', 
//   borderLeft: '4px solid #007bff',
//   fontWeight: '700'
// };

// const logContainer = {
//   backgroundColor: '#fff',
//   border: '1px solid #e2e8f0',
//   borderRadius: '10px',
//   overflow: 'hidden',
//   boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
// };

// const logHeader = {
//   backgroundColor: '#f8fafc',
//   padding: '12px 20px',
//   borderBottom: '1px solid #e2e8f0',
//   display: 'flex',
//   justifyContent: 'space-between',
//   fontSize: '11px',
//   fontWeight: '800',
//   color: '#64748b',
//   textTransform: 'uppercase',
//   letterSpacing: '0.5px'
// };

// const logBody = {
//   display: 'flex',
//   flexDirection: 'column'
// };

// const logItem = {
//   display: 'flex',
//   gap: '15px',
//   padding: '15px 20px',
//   borderBottom: '1px solid #f1f5f9',
//   alignItems: 'flex-start'
// };

// const logIcon = {
//   fontSize: '16px',
//   marginTop: '2px'
// };

// const logText = {
//   fontSize: '13px',
//   color: '#334155',
//   lineHeight: '1.4'
// };

// const logTime = {
//   fontSize: '11px',
//   color: '#94a3b8',
//   fontWeight: '500'
// };

// export default Home;

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CompanyLogos from './CompanyLogos'; 

const Home = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false); 
  const [activeTab, setActiveTab] = useState(0); 
  const [isExporting, setIsExporting] = useState(false);
  const [isAnimalsOpen, setIsAnimalsOpen] = useState(true);
  const [isInfraOpen, setIsBusinessOpen] = useState(false);

  // --- MOBILE DETECTION LOGIC ---
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const handleExport = () => {
    setIsExporting(true);
    setTimeout(() => setIsExporting(false), 2000);
  };

  return (
    <div className="home-container" style={{ fontFamily: 'Inter, sans-serif', color: '#0f172a' }}>
      
      {/* 1. HERO SECTION */}
      <section id="hero" style={{ ...heroSectionStyle, padding: isMobile ? '60px 20px' : '120px 20px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h1 style={{ ...mainHeaderStyle, fontSize: isMobile ? '36px' : '56px' }}>
            Architecting Technical Legacies for <br/> 
            <span style={{color: '#007bff'}}>Mission-Critical Data</span>
          </h1>
          <p style={{ ...heroSubtextStyle, fontSize: isMobile ? '18px' : '20px' }}>
            We engineer high-performance software and relational models designed to ensure 
            institutional data remains stable, secure, and analyst-ready. Since 1986.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
            <button onClick={openPopup} style={primaryButtonStyle}>Discuss Your Architecture</button>
            <Link to="/case-studies" style={secondaryLinkStyle}>View Success Stories</Link>
          </div>
        </div>
      </section>

      {/* 2. LOGO GRID */}
      <section style={ribbonStyle}>
        <p style={ribbonTextStyle}>Technical Partners to National Research Boards & Industry Groups</p>
        <CompanyLogos /> 
      </section>

      {/* 3. INTERACTIVE PLATFORM PREVIEW */}
      <section id="platform-preview" style={{ padding: isMobile ? '40px 10px' : '80px 20px', backgroundColor: '#f4f6f9', textAlign: 'center' }}>
        <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
          <h2 style={{ fontSize: isMobile ? '24px' : '32px', fontWeight: '800', marginBottom: '10px' }}>Platform Interface Preview</h2>
          <p style={{ color: '#64748b', marginBottom: isMobile ? '20px' : '40px', fontSize: '15px' }}>Interface preview of our custom reporting and data access portal.</p>

          <div style={browserFrameStyle}>
            {/* Top Bar */}
            <div style={{ ...browserHeaderStyle, flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '15px' : '0' }}>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {!isMobile && (
                  <>
                    <div style={dotStyle('#ff5f56')} />
                    <div style={dotStyle('#ffbd2e')} />
                    <div style={dotStyle('#27c93f')} />
                  </>
                )}
                <span style={breadcrumbStyle}>
                   Beef &gt; {activeTab === 0 ? 'Dashboard' : activeTab === 1 ? 'Reports' : 'Analysis'}
                </span>
              </div>
              <div style={{ ...tabSwitcherStyle, width: isMobile ? '100%' : 'auto', overflowX: 'auto' }}>
                <button onClick={() => setActiveTab(0)} style={activeTab === 0 ? activeBtn : inactiveBtn}>🏠 Dashboard</button>
                <button onClick={() => setActiveTab(1)} style={activeTab === 1 ? activeBtn : inactiveBtn}>📊 Reports</button>
                <button onClick={() => setActiveTab(2)} style={activeTab === 2 ? activeBtn : inactiveBtn}>🧬 Analysis</button>
              </div>
              {!isMobile && <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#94a3b8' }}>USER: RESEARCH_01</div>}
            </div>

            {/* Application Body */}
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '520px' }}>
              
              {/* Sidebar (Stacks on top on Mobile) */}
              <div style={{ ...sidebarStyle, width: isMobile ? '100%' : '240px', borderRight: isMobile ? 'none' : '1px solid #334155', borderBottom: isMobile ? '1px solid #334155' : 'none' }}>
                <div style={sidebarLabelStyle}>NAVIGATION TREE</div>
                
                <div onClick={() => setIsAnimalsOpen(!isAnimalsOpen)} style={folderHeaderStyle}>
                  <span>{isAnimalsOpen ? '▼' : '▶'} 📂 Animals</span>
                </div>
                <div style={collapseContainer(isAnimalsOpen)}>
                  <div style={activeTab === 1 ? sidebarItemActive : sidebarItem}>🥩 Beef</div>
                  <div style={sidebarItem}>🐖 Swine</div>
                  <div style={sidebarItem}>🐔 Chickens</div>
                </div>

                <div onClick={() => setIsBusinessOpen(!isInfraOpen)} style={folderHeaderStyle}>
                  <span>{isInfraOpen ? '▼' : '▶'} 📂 Infrastructure</span>
                </div>
                <div style={collapseContainer(isInfraOpen)}>
                  <div style={sidebarItem}>📊 System Audit Logs</div>
                  <div style={sidebarItem}>🔑 Access Control</div>
                </div>
              </div>

              {/* Main Content Workspace */}
              <div style={{ flex: 1, padding: '0', textAlign: 'left', backgroundColor: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                
                {/* TAB 0: DASHBOARD */}
                {activeTab === 0 && (
                  <div style={{ padding: isMobile ? '20px' : '30px' }}>
                    <h3 style={tabTitleStyle}>Dashboard</h3>
                    <div style={{ ...dashboardGrid, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr' }}>
                      <div style={statCard}>Total Records<br/><span style={statNum}>1,248,302</span></div>
                      <div style={statCard}>Active Surveys<br/><span style={statNum}>14</span></div>
                      <div style={statCard}>Uptime<br/><span style={statNum}>99.9%</span></div>
                    </div>

                    <div style={logContainer}>
                      <div style={logHeader}><span>Recent Activity</span><span style={{ color: '#10b981' }}>● Live</span></div>
                      <div style={logBody}>
                        <div style={logItem}>
                          <span style={logIcon}>📥</span>
                          <div style={logText}><strong>Report Exported:</strong> Swine (xlsx)<br/><span style={logTime}>5m ago • User: RES_04</span></div>
                        </div>
                        <div style={{ ...logItem, borderBottom: 'none' }}>
                          <span style={logIcon}>✅</span>
                          <div style={logText}><strong>Backup Sync:</strong> PostgreSQL Master<br/><span style={logTime}>1h ago • System: Admin</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* TAB 1: REPORTS */}
                {activeTab === 1 && (
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
                    <div style={{ ...gridToolbar, flexDirection: isMobile ? 'column' : 'row', gap: '10px' }}>
                      <span style={gridStat}>Rows: 1,248 | Columns: 32</span>
                      <button onClick={handleExport} style={{ ...exportBtn, width: isMobile ? '100%' : 'auto' }}>
                        {isExporting ? '⌛ Exporting...' : '📥 Export to Excel'}
                      </button>
                    </div>
                    {/* SCROLLABLE GRID FOR MOBILE */}
                    <div style={{ flex: 1, overflowX: 'auto', backgroundColor: '#fff' }}>
                      <div style={{ ...delphiGridStyle, minWidth: isMobile ? '600px' : 'auto' }}>
                        <div style={gridHeader}>
                          <div style={gridCell}>Year</div>
                          <div style={gridCell}>Code</div>
                          <div style={gridCell}>ID</div>
                          <div style={gridCell}>Class</div>
                          <div style={gridCell}>Dosage</div>
                        </div>
                        {[1, 2, 3, 4, 5].map(i => (
                          <div key={i} style={gridRow(i % 2 === 0)}>
                            <div style={gridCell}>2026</div>
                            <div style={gridCell}>VET{i}</div>
                            <div style={gridCell}>HRD{i}</div>
                            <div style={gridCell}>Class_A</div>
                            <div style={gridCell}>{(Math.random() * 5).toFixed(1)}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* TAB 2: ANALYSIS */}
                {activeTab === 2 && (
                  <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', height: '100%' }}>
                    {!isMobile && (
                      <div style={dbTreeStyle}>
                        <div style={sidebarLabelStyle}>DATABASE</div>
                        <div style={treeItem}>▼ Surveillance</div>
                        <div style={treeSubItem}>• Staging</div>
                        <div style={treeSubItem}>• Reports</div>
                      </div>
                    )}
                    <div style={{ flex: 1, padding: '20px', backgroundColor: '#1e293b', overflow: 'hidden' }}>
                      <div style={codeEditorHeader}>SQL Syntax Editor</div>
                      <pre style={{ ...codeStyle, fontSize: isMobile ? '11px' : '13px' }}>
                        {`SELECT \n  t00.year, \n  t00.code \nFROM \n  "public"."beef" t00 \nORDER BY year DESC;`}
                      </pre>
                      <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        <button style={analysisBtn('#10b981')}>🚀 Run</button>
                        <button style={analysisBtn('#6366f1')}>📊 R-Studio</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. FOOTER */}
      <section style={{ padding: isMobile ? '60px 20px' : '100px 20px', textAlign: 'center', backgroundColor: '#0f172a', color: '#fff' }}>
        <h2 style={{ fontSize: isMobile ? '28px' : '36px', fontWeight: '800', marginBottom: '20px' }}>Systems Built for the Long Term</h2>
        <p style={{ maxWidth: '700px', margin: '0 auto 40px', color: '#94a3b8', fontSize: isMobile ? '16px' : '18px' }}>
          Our relational models and analysis pipelines have powered national research initiatives for over 15 years.
        </p>
        <Link to="/case-studies" style={footerCtaStyle}>Explore Success Stories →</Link>
      </section>

      {/* 5. POPUP MODAL */}
      {isPopupOpen && (
        <div style={overlayStyle}>
          <div style={{ ...popupStyle, width: isMobile ? '95%' : '500px', padding: isMobile ? '30px' : '50px' }}>
            <h2 style={headerStyle}>Discuss Your Architecture</h2>
            <p style={taglineStyle}>Connect with our engineering team for a feasibility review.</p>
            <div style={{ margin: '30px 0', padding: '20px', backgroundColor: '#f1f5f9', borderRadius: '8px' }}>
              <a href="mailto:info@yrcgi.com" style={{ ...emailLinkStyle, fontSize: isMobile ? '18px' : '24px' }}>info@yrcgi.com</a>
            </div>
            <button onClick={closePopup} style={closeButtonStyle}>Close Window</button>
          </div>
        </div>
      )}
    </div>
  );
};

// ================= STYLES (Consolidated & Error-Free) =================

const dotStyle = (color) => ({ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: color });
const gridRow = (isEven) => ({ display: 'grid', gridTemplateColumns: '60px 80px 80px 1fr 80px', backgroundColor: isEven ? '#fcfcfd' : '#fff', borderBottom: '1px solid #f1f5f9', fontSize: '12px' });
const analysisBtn = (color) => ({ backgroundColor: color, color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '4px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' });

const breadcrumbStyle = { fontSize: '12px', fontWeight: '600', color: '#94a3b8', fontFamily: 'monospace' };
const browserFrameStyle = { backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 30px 60px -12px rgba(0,0,0,0.15)' };
const browserHeaderStyle = { backgroundColor: '#0f172a', padding: '15px 25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' };

const tabSwitcherStyle = { display: 'flex', gap: '4px', backgroundColor: '#1e293b', padding: '4px', borderRadius: '8px' };
const activeBtn = { backgroundColor: '#007bff', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', cursor: 'pointer', whiteSpace: 'nowrap' };
const inactiveBtn = { backgroundColor: 'transparent', color: '#94a3b8', border: 'none', padding: '8px 14px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' };

const sidebarStyle = { backgroundColor: '#1e293b', display: 'flex', flexDirection: 'column', textAlign: 'left', padding: '20px 0' };
const sidebarLabelStyle = { fontSize: '10px', fontWeight: '800', color: '#38bdf8', padding: '0 20px 12px', letterSpacing: '1px' };
const sidebarItem = { padding: '8px 25px', fontSize: '12px', color: '#94a3b8', cursor: 'default' };
const sidebarItemActive = { ...sidebarItem, backgroundColor: '#334155', color: '#fff', borderLeft: '4px solid #007bff', fontWeight: '700' };

const folderHeaderStyle = { padding: '10px 20px', fontSize: '13px', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', userSelect: 'none', fontWeight: '600' };
const collapseContainer = (isOpen) => ({ maxHeight: isOpen ? '300px' : '0', overflow: 'hidden', transition: 'all 0.3s ease-in-out', paddingLeft: '10px' });

const gridToolbar = { padding: '15px 25px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc' };
const gridStat = { fontSize: '11px', fontWeight: '700', color: '#64748b' };
const exportBtn = { backgroundColor: '#10b981', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' };

const delphiGridStyle = { display: 'flex', flexDirection: 'column' };
const gridHeader = { display: 'grid', gridTemplateColumns: '60px 80px 80px 1fr 80px', backgroundColor: '#f1f5f9', borderBottom: '1px solid #e2e8f0', fontWeight: 'bold', fontSize: '11px', color: '#475569', textTransform: 'uppercase' };
const gridCell = { padding: '12px' };

const dbTreeStyle = { width: '200px', borderRight: '1px solid #334155', backgroundColor: '#0f172a', padding: '20px 0', textAlign: 'left' };
const treeItem = { padding: '8px 20px', color: '#fff', fontSize: '12px', fontWeight: 'bold' };
const treeSubItem = { padding: '6px 35px', color: '#38bdf8', fontSize: '11px' };

const codeStyle = { color: '#4ade80', lineHeight: '1.6', fontFamily: 'monospace', whiteSpace: 'pre-wrap', textAlign: 'left' };
const codeEditorHeader = { color: '#94a3b8', fontSize: '11px', marginBottom: '15px', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'left' };

const tabTitleStyle = { fontSize: '22px', fontWeight: '800', marginBottom: '20px' };
const dashboardGrid = { display: 'grid', gap: '15px', marginBottom: '30px' };
const statCard = { padding: '15px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '11px', color: '#64748b' };
const statNum = { fontSize: '20px', fontWeight: '900', color: '#0f172a' };

const logContainer = { backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' };
const logHeader = { backgroundColor: '#f8fafc', padding: '10px 15px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', fontSize: '10px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase' };
const logBody = { display: 'flex', flexDirection: 'column' };
const logItem = { display: 'flex', gap: '12px', padding: '12px 15px', borderBottom: '1px solid #f1f5f9', alignItems: 'flex-start' };
const logIcon = { fontSize: '14px' };
const logText = { fontSize: '12px', color: '#334155', lineHeight: '1.4' };
const logTime = { fontSize: '10px', color: '#94a3b8' };

const heroSectionStyle = { textAlign: 'center', background: 'radial-gradient(circle at center, #fff 0%, #f8fafc 100%)' };
const mainHeaderStyle = { fontWeight: '900', letterSpacing: '-1px', marginBottom: '25px' };
const heroSubtextStyle = { color: '#475569', maxWidth: '850px', margin: '0 auto 40px', lineHeight: '1.6' };

const primaryButtonStyle = { backgroundColor: '#007bff', color: '#fff', padding: '16px 32px', borderRadius: '6px', fontWeight: '700', border: 'none', cursor: 'pointer', fontSize: '16px' };
const secondaryLinkStyle = { backgroundColor: 'transparent', color: '#0f172a', padding: '16px 32px', borderRadius: '6px', fontWeight: '700', border: '1px solid #cbd5e1', textDecoration: 'none', display: 'inline-block' };

const ribbonStyle = { padding: '40px 20px', backgroundColor: '#fff', borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', textAlign: 'center' };
const ribbonTextStyle = { fontSize: '11px', fontWeight: '800', letterSpacing: '2px', color: '#94a3b8', marginBottom: '25px' };

const footerCtaStyle = { display: 'inline-block', backgroundColor: '#007bff', color: '#fff', padding: '16px 32px', borderRadius: '6px', fontWeight: '700', textDecoration: 'none' };

const overlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(15, 23, 42, 0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
const popupStyle = { backgroundColor: '#fff', borderRadius: '20px', textAlign: 'center' };
const emailLinkStyle = { fontWeight: '800', color: '#007bff', textDecoration: 'none' };
const headerStyle = { fontSize: '28px', fontWeight: '800', marginBottom: '10px' };
const taglineStyle = { color: '#64748b', fontSize: '16px' };
const closeButtonStyle = { background: 'none', border: 'none', color: '#94a3b8', textDecoration: 'underline', cursor: 'pointer', marginTop: '20px' };

export default Home;